import { date } from 'quasar';

const formatDate = 'DD.MM.YYYY';
const msInDay = 86400000;

export function useRangeDate() {
  const now = new Date();

  const recent = 'recent' as const;
  const toDay = date.formatDate(now, 'DD.MM.YYYY');
  const yesterday = date.formatDate(new Date(now.getTime() - msInDay), formatDate);
  const three = date.formatDate(new Date(now.getTime() - 3 * msInDay), formatDate);
  const week = date.formatDate(new Date(now.getTime() - 7 * msInDay), formatDate);
  const month = date.formatDate(new Date(now.getTime() - 30 * msInDay), formatDate);

  const addMonthDays = (inputDate: string | null) => {
    if (!inputDate) return '';
    const d = new Date(inputDate.split('.').reverse().join('-')); // "DD.MM.YYYY" -> "YYYY-MM-DD"
    d.setDate(d.getDate() + 30);
    return date.formatDate(d, formatDate);
  };

  const subtractMonthDays = (inputDate: string) => {
    const d = new Date(inputDate.split('.').reverse().join('-'));
    d.setDate(d.getDate() - 30);
    return date.formatDate(d, formatDate);
  };
  return {
    week,
    month,
    recent,
    yesterday,
    toDay,
    three,
    addMonthDays,
    subtractMonthDays,
  };
}
